import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_STRIPE } from './router';

menuRegistry.registerMenu([
    {
        parent: 'ThirdParty',
        key: 'Stripe',
        name: 'Stripe',
        icon: 'fab fa-stripe',
        route: { name: ROUTE_NAME_STRIPE }
    }
]);

export default registerRouteForModule(router);
